import request from '../axios'
import requestSec from '../axiosSec'

// 项目追踪
// 获取全部项目
export const projecttrackingprojectList = params => request({
	url: 'tracking/projecttrackingproject/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 创建项目
export const projecttrackingprojectAdd = data => request({
	url: 'tracking/projecttrackingproject/add',
	method: 'post',
	data: data,
})

// 移动项目
export const projecttrackingprojectMoveProject = params => request({
	url: 'tracking/projecttrackingproject/moveProject',
	method: 'get',
	params: params
})

// 获取项目详情
export const projecttrackingprojectInfo = params => request({
	url: 'tracking/projecttrackingproject/info/' + params.id,
	method: 'get'
})

// 编辑项目
export const projecttrackingprojectUpdate = data => request({
	url: 'tracking/projecttrackingproject/update',
	method: 'post',
	data: data,
})

// 获取项目成员（全部）
export const projecttrackingmemberList = params => request({
	url: 'tracking/projecttrackingmember/list',
	method: 'get',
	params: params
})

// 获取项目成员（部门等树形结构）
export const projecttrackingprojectGetMemberCanAdd = params => request({
	url: 'tracking/projecttrackingproject/getMemberCanAdd',
	method: 'get',
	params: params
})

// 新增项目成员
export const projecttrackingmemberAddMember = data => request({
	url: 'tracking/projecttrackingmember/addMember',
	method: 'post',
	data: data,
})

// 删除项目成员
export const projecttrackingmemberDelete = data => request({
	url: 'tracking/projecttrackingmember/delete',
	method: 'post',
	data: data,
})

// 删除全部项目成员
export const projecttrackingmemberDeleteAll = params => request({
	url: 'tracking/projecttrackingmember/deleteAll',
	method: 'get',
	params: params
})

// 删除项目
export const projecttrackingprojectDelete = data => request({
	url: 'tracking/projecttrackingproject/delete',
	method: 'post',
	data: data,
})

// 项目详情--获取数据统计
export const projecttrackingprojectStatistics = params => request({
	url: 'tracking/projecttrackingproject/statistics',
	method: 'get',
	params: params
})

// 获取模块列表
export const projecttrackingmoduleList = params => request({
	url: 'tracking/projecttrackingmodule/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 跟随记忆--获取展开的模块id
export const projecttrackingmodulehierarchyShowHierarchyService = params => request({
	url: 'tracking/projecttrackingmodulehierarchy/showHierarchyService',
	method: 'get',
	params: params
})

// 跟随记忆--展开/收起模块
export const projecttrackingmodulehierarchySettingHierarchyService = data => request({
	url: 'tracking/projecttrackingmodulehierarchy/settingHierarchyService',
	method: 'post',
	data: data,
})

// 创建模块
export const projecttrackingmoduleAddModule = data => request({
	url: 'tracking/projecttrackingmodule/addModule',
	method: 'post',
	data: data,
})

// 获取模块详情
export const projecttrackingmoduleInfo = params => request({
	url: 'tracking/projecttrackingmodule/info/' + params.id,
	method: 'get'
})

// 获取模块子集需求
export const projecttrackingmoduleRequirementList = params => request({
	url: 'tracking/projecttrackingmodule/requirementList',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260312修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 编辑模块(附件务必全量附件ID)
export const projecttrackingmoduleUpdateModule = data => request({
	url: 'tracking/projecttrackingmodule/updateModule',
	method: 'post',
	data: data,
})

// 编辑模块(附件务必全量附件ID)(直接修改状态 协助人 负责人/处理人 附件时调用)
export const projecttrackingmoduleUpdateModuleSimplify = data => request({
	url: 'tracking/projecttrackingmodule/updateModule/simplify',
	method: 'post',
	data: data,
})

// 删除模块
export const projecttrackingmoduleDelete = data => request({
	url: 'tracking/projecttrackingmodule/delete',
	method: 'post',
	data: data,
})

// 发表/回复评论
export const projecttrackingcommentIissue = data => request({
	url: 'tracking/projecttrackingcomment/issue',
	method: 'post',
	data: data,
})

// 获取评论列表
export const projecttrackingcommentList = params => request({
	url: 'tracking/projecttrackingcomment/list',
	method: 'get',
	params: params
})

// 评论获取成员信息
export const sysuserGetUserByName = params => request({
	url: 'sys/sysuser/getUserByName',
	method: 'get',
	params: params
})

// 删除评论
export const projecttrackingcommentDelete = data => request({
	url: 'tracking/projecttrackingcomment/delete',
	method: 'post',
	data: data,
})

// 创建需求
export const projecttrackingrequirementAddRequirement = data => request({
	url: 'tracking/projecttrackingrequirement/addRequirement',
	method: 'post',
	data: data,
})

// 获取需求详情
export const projecttrackingrequirementInfo = params => request({
	url: 'tracking/projecttrackingrequirement/info/' + params.id,
	method: 'get'
})

// 编辑需求
export const projecttrackingrequirementUpdateRequirement = data => request({
	url: 'tracking/projecttrackingrequirement/updateRequirement',
	method: 'post',
	data: data,
})

// 编辑需求(直接修改状态 协助人 负责人/处理人 附件时调用)
export const projecttrackingrequirementUpdateRequirementSimplify = data => request({
	url: 'tracking/projecttrackingrequirement/updateRequirement/simplify',
	method: 'post',
	data: data,
})

// 删除需求
export const projecttrackingrequirementDelete = data => request({
	url: 'tracking/projecttrackingrequirement/delete',
	method: 'post',
	data: data,
})

// 批量删除需求
export const projecttrackingrequirementDeleteBatch = data => request({
	url: 'tracking/projecttrackingrequirement/deleteBatch',
	method: 'post',
	data: data,
})

// @获取成员列表
export const projecttrackingmemberGetProjectUsers = params => request({
	url: 'tracking/projecttrackingmember/getProjectUsers',
	method: 'get',
	params: params
})

// 获取我的待办/创建列表 来源，toDo表示待办，my表示我创建，不可为空
export const projecttrackingrequirementList = params => request({
	url: 'tracking/projecttrackingrequirement/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取待协助项
export const projecttrackingassistuserList = params => request({
	url: 'tracking/projecttrackingassistuser/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取项目配置
export const configprojecttrackingInfo = params => request({
	url: 'config/configprojecttracking/info',
	method: 'get',
	params: params
})

// 设置项目配置
export const configprojecttrackingSetDefaultDeploy = data => request({
	url: 'config/configprojecttracking/setDefaultDeploy',
	method: 'post',
	data: data,
})

// 设置项目许可
export const configprojecttrackingSetExportStatus = data => request({
	url: 'config/configprojecttracking/setExportStatus',
	method: 'post',
	data: data,
})

// 系统用量
// export const projecttrackingstageAll = params => request({
// 	url: 'tracking/projecttrackingstage/all',
// 	method: 'get',
// 	params: params
// })

// 获取项目阶段
export const projecttrackingstageAll = params => request({
	url: 'tracking/projecttrackingstage/all',
	method: 'get',
	params: params
})

// 新增项目阶段
export const projecttrackingstageSave = data => request({
	url: 'tracking/projecttrackingstage/save',
	method: 'post',
	data: data,
})

// 编辑项目阶段
export const projecttrackingstageUpdate = data => request({
	url: 'tracking/projecttrackingstage/update',
	method: 'post',
	data: data,
})

// 删除项目阶段
export const projecttrackingstageDelete = data => request({
	url: 'tracking/projecttrackingstage/delete',
	method: 'post',
	data: data,
})

// 获取系统用量
export const configprojecttrackingGetSystemConsumption = params => request({
	url: 'config/configprojecttracking/getSystemConsumption',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取相关权限的校验
export const projecttrackingprojectPowerAbout = data => request({
	url: 'tracking/projecttrackingproject/powerAbout',
	method: 'post',
	data: data,
})

// 根据父评论获取子评论
export const projecttrackingcommentListChildren = params => request({
	url: 'tracking/projecttrackingcomment/listChildren',
	method: 'get',
	params: params
})

// 获取最近指定成员列表
export const projecttrackinglastappointList = params => request({
	url: 'tracking/projecttrackinglastappoint/list',
	method: 'get',
	params: params
})

// 保存最近指定成员数据
export const projecttrackinglastappointSaveAppoint = data => request({
	url: 'tracking/projecttrackinglastappoint/saveAppoint',
	method: 'post',
	data: data,
})

// 获取我的待办/我的创建/待协助项涉及项目
export const projecttrackingprojectListProjectAboutMe = params => request({
	url: 'tracking/projecttrackingproject/listProjectAboutMe',
	method: 'get',
	params: params
})

// 根据项目ID获取项目所在页码
export const projecttrackingprojectGetMemberWhere = params => request({
	url: 'tracking/projecttrackingproject/getMemberWhere',
	method: 'get',
	params: params
})

// 需求日志接口
export const projecttrackingrequirementRecordLog = data => request({
	url: 'tracking/projecttrackingrequirement/recordLog',
	method: 'post',
	data: data,
})

// 设置项目字体大小
export const configprojecttrackingSetFontSize = data => request({
	url: 'config/configprojecttracking/setFontSize',
	method: 'post',
	data: data,
})

// 项目看板--综合看板--项目汇总
export const noticeboardOverallProject = params => request({
	url: 'tracking/noticeboard/overall/project',
	method: 'get',
	params: params
})

// 项目看板--综合看板--模块汇总
export const noticeboardOverallModule = params => request({
	url: 'tracking/noticeboard/overall/module',
	method: 'get',
	params: params
})

// 项目看板--综合看板--需求汇总
export const noticeboardOverallRequirement = params => request({
	url: 'tracking/noticeboard/overall/requirement',
	method: 'get',
	params: params
})

// 项目看板--综合看板--项目-负责人排名列表数据
export const noticeboardDetailsProjectChargeList = params => request({
	url: 'tracking/noticeboard/details/projectCharge/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--项目-负责人排名详情
export const noticeboardDetailsProjectChargeDetails = params => request({
	url: 'tracking/noticeboard/details/projectCharge/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--模块-创建排名列表数据
export const noticeboardDetailsModuleCreateList = params => request({
	url: 'tracking/noticeboard/details/moduleCreate/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--模块-创建排名详情
export const noticeboardDetailsModuleCreateDetails = params => request({
	url: 'tracking/noticeboard/details/moduleCreate/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--模块-负责人排名列表数据
export const noticeboardDetailsModuleChargeList = params => request({
	url: 'tracking/noticeboard/details/moduleCharge/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--模块-负责人排名详情
export const noticeboardDetailsModuleChargeDetails = params => request({
	url: 'tracking/noticeboard/details/moduleCharge/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--模块-完成排名列表数据
export const noticeboardDetailsModuleFinishList = params => request({
	url: 'tracking/noticeboard/details/moduleFinish/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--模块-完成排名详情
export const noticeboardDetailsModuleFinishDetails = params => request({
	url: 'tracking/noticeboard/details/moduleFinish/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--需求-创建排名列表数据
export const noticeboardDetailsRequirementCreateList = params => request({
	url: 'tracking/noticeboard/details/requirementCreate/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--需求-创建排名详情
export const noticeboardDetailsRequirementCreateDetails = params => request({
	url: 'tracking/noticeboard/details/requirementCreate/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--需求-处理排名列表数据
export const noticeboardDetailsRequirementDealList = params => request({
	url: 'tracking/noticeboard/details/requirementDeal/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--需求-处理排名详情
export const noticeboardDetailsRequirementDealDetails = params => request({
	url: 'tracking/noticeboard/details/requirementDeal/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--需求-完成排名列表数据
export const noticeboardDetailsRequirementFinishList = params => request({
	url: 'tracking/noticeboard/details/requirementFinish/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--需求-完成排名详情
export const noticeboardDetailsRequirementFinishDetails = params => request({
	url: 'tracking/noticeboard/details/requirementFinish/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--需求-协助排名列表数据
export const noticeboardDetailsRequirementAssistList = params => request({
	url: 'tracking/noticeboard/details/requirementAssist/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--需求-协助排名详情
export const noticeboardDetailsRequirementAssistDetails = params => request({
	url: 'tracking/noticeboard/details/requirementAssist/details/' + params.id,
	method: 'get'
})

// 项目看板--综合看板--需求-验收排名列表数据
export const noticeboardDetailsRequirementCheckList = params => request({
	url: 'tracking/noticeboard/details/requirementCheck/list',
	method: 'get',
	params: params
})

// 项目看板--综合看板--需求-验收排名详情
export const noticeboardDetailsRequirementCheckDetails = params => request({
	url: 'tracking/noticeboard/details/requirementCheck/details/' + params.id,
	method: 'get'
})

// 项目看板--成员看板--顶部筛选框
export const noticeboardMemberTopData = data => request({
	url: 'tracking/noticeboard/member/top/data',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--效率汇总
export const noticeboardMemberEfficiency = data => request({
	url: 'tracking/noticeboard/member/efficiency',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--模块汇总
export const noticeboardMemberModule = data => request({
	url: 'tracking/noticeboard/member/module',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求汇总
export const noticeboardMemberRequirement = data => request({
	url: 'tracking/noticeboard/member/requirement',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--年度对比
export const noticeboardDetailsMemberMemberEfficiencyByYearList = data => request({
	url: 'tracking/noticeboard/details/member/memberEfficiencyByYearList',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--模块完成情况详情
export const noticeboardDetailsMemberMemberModuleFinish = data => request({
	url: 'tracking/noticeboard/details/member/module/finish',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--模块验收记录详情
export const noticeboardDetailsMemberMemberModuleCheck = data => request({
	url: 'tracking/noticeboard/details/member/module/check',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--模块负责情况详情
export const noticeboardDetailsMemberMemberModuleCharge = data => request({
	url: 'tracking/noticeboard/details/member/module/charge',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--模块创建情况详情
export const noticeboardDetailsMemberMemberModuleCreate = data => request({
	url: 'tracking/noticeboard/details/member/module/create',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求完成情况详情
export const noticeboardDetailsMemberMemberRequirementFinish = data => request({
	url: 'tracking/noticeboard/details/member/requirement/finish',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求完成协助情况详情
export const noticeboardDetailsMemberMemberRequirementFinishAssist = data => request({
	url: 'tracking/noticeboard/details/member/requirement/finishAssist',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求处理情况详情
export const noticeboardDetailsMemberMemberRequirementCharge = data => request({
	url: 'tracking/noticeboard/details/member/requirement/charge',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求处理协助情况详情
export const noticeboardDetailsMemberMemberRequirementChargeAssist = data => request({
	url: 'tracking/noticeboard/details/member/requirement/chargeAssist',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求创建情况详情
export const noticeboardDetailsMemberMemberRequirementCreate = data => request({
	url: 'tracking/noticeboard/details/member/requirement/create',
	method: 'post',
	data: data,
})

// 项目看板--成员看板--需求验收记录详情
export const noticeboardDetailsMemberMemberRequirementCheck = data => request({
	url: 'tracking/noticeboard/details/member/requirement/check',
	method: 'post',
	data: data,
})

// 项目配置--修改项目阶段（批量）
export const projecttrackingstageUpdateBatch = data => request({
	url: 'tracking/projecttrackingstage/updateBatch',
	method: 'post',
	data: data,
})

// 需求列入更新计划根据项目id获取更新版本弹窗数据
export const sysupdatedocumentGetDocumentList = params => request({
	url: 'sys/sysupdatedocument/getDocumentList',
	method: 'get',
	params: params
})

// 列入更新--保存
export const sysupdatedocumentSaveDocumentLogRequirement = data => request({
	url: 'sys/sysupdatedocument/saveDocumentLogRequirement',
	method: 'post',
	data: data
})

// 更改归属模块--获取当前项目全部模块
export const projecttrackingmoduleModuleListByProjectId = params => request({
	url: 'tracking/projecttrackingmodule/moduleListByProjectId',
	method: 'get',
	params: params
})

// 更改归属模块--保存
export const projecttrackingrequirementChangeRequirementModule = data => request({
	url: 'tracking/projecttrackingrequirement/changeRequirementModule',
	method: 'post',
	data: data
})

// 分享前检测需求、模块、项目是否存在
export const projecttrackingrequirementCheckShare = data => request({
	url: 'tracking/projecttrackingrequirement/checkShare',
	method: 'post',
	data: data
})

// 变更日志（项目/模块/需求）
export const syschangelogListProject = params => request({
	url: 'sys/syschangelog/listProject',
	method: 'get',
	params: params
})

// 变更日志（项目/模块/需求）
export const syschangelogDetailed = data => request({
	url: 'sys/syschangelog/detailed',
	method: 'post',
	data: data
})